import apiClient from '../apiClient';
import { GET_ACCOMODATION_BYPROFILE_ID_URL } from '../apiUrl';

const getAccomodationByProfileIdApi = Id => {
  return apiClient.get(GET_ACCOMODATION_BYPROFILE_ID_URL(Id));
};

export default getAccomodationByProfileIdApi;
